import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import PublishDiffItem from "./PublishDiffItem";


export default function PublishDiff({children, resourceType = 'campaign', setSkipBundleUpdateList, skipBundleUpdateList, cachedItems, env1, env2, campaigns, showConfirmTransfer, setShowConfirmTransfer, onBundleUpdateInfo}) {
    return <>
        <Dialog
            open={showConfirmTransfer}
            onClose={setShowConfirmTransfer}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xl"
            fullWidth={true}
        >
            <DialogTitle id="alert-dialog-title">
                Transfer {resourceType === 'template' ? 'template' : 'campaign'} from <strong>{env1}</strong> to <strong>{env2}</strong>
            </DialogTitle>
            <DialogContent>
                {campaigns.map((campaign) => <PublishDiffItem
                    key={campaign}
                    resourceType={resourceType}
                    env1={env1}
                    env2={env2}
                    setSkipBundleUpdateList={setSkipBundleUpdateList}
                    skipBundleUpdateList={skipBundleUpdateList}
                    oldItem={cachedItems[campaign]}
                    campaignId={campaign}
                    onBundleUpdateInfo={onBundleUpdateInfo}
                />)}
            </DialogContent>
            <DialogActions>
                {children}
            </DialogActions>
        </Dialog>
    </>
}
